import { Dayjs } from 'dayjs';

export enum TimeActive {
  THIS_MONTH = 'M',
  THIS_WEEK = 'W',
  CUSTOM = 'D',
  HOUR = 'H',
}
export type RangeValue = [Dayjs, Dayjs];
